
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/plugins/scrollo/js/scrollo';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/plugins/auto-hide-bar/js/auto-hide-bar';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/plugins/stickyElements/js/stickyElements';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/components/coolbar/js/coolbar';
  
const main = (UX) => {
    const $scrollo = Array.prototype.slice.call(document.querySelectorAll('.table-fn, .ref.fn, .scroll-to-target')),
        $autoHideBar = Array.prototype.slice.call(document.getElementsByClassName('auto-hide-primary-bar')),
        $coolbar = Array.prototype.slice.call(document.getElementsByClassName('coolBar'))

try {
        if ($scrollo.length ) {
            UX.scrollo.init($scrollo);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($autoHideBar.length ) {
            UX.autoHideBar.init($autoHideBar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.stickyElements.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($coolbar.length ) {
            UX.coolbar.init($coolbar);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        